(function () {
  'use strict';

  function updateDescription(field) {
    const wrapper = field.closest('.variant-picker__field-wrapper') || field.parentElement;
    if (!wrapper) return;
    const container = wrapper.querySelector('[data-occasion-description]');
    if (!container) return;

    let value = null;
    const checked = field.querySelector('input[type="radio"]:checked');
    if (checked) {
      value = checked.value;
    } else {
      const select = field.querySelector('select');
      if (select) value = select.value;
    }
    if (!value) return;

    container.querySelectorAll('[data-state]').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.state === value);
    });
  }

  document.addEventListener('change', function (e) {
    const field = e.target.closest('.variant-picker__field');
    if (!field) return;
    const wrapper = field.closest('.variant-picker__field-wrapper');
    if (!wrapper || !wrapper.querySelector('[data-occasion-description]')) return;
    updateDescription(field);
  });
})();
